"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTopFiveElectricalEnergyUsage = void 0;
const react_1 = require("react");
const useElectricalWithHVAC_1 = require("./useElectricalWithHVAC");
const MAXIMUM_DEVICE_COUNT = 5;
const useGetTopFiveElectricalEnergyUsage = ({ selectedHub, sensors, }) => {
    const { branches } = (0, useElectricalWithHVAC_1.useElectricalWithHVAC)({ selectedHub, sensors });
    const [devices, setDevices] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        const topFive = branches
            .map((entry) => {
            const power = Number((entry.branchCT * entry.voltage).toFixed(2));
            return {
                name: entry.name,
                value: power,
                power,
                percentOfTotal: Number(entry.percent),
            };
        })
            .sort((a, b) => b.power - a.power)
            .slice(0, MAXIMUM_DEVICE_COUNT);
        setDevices(topFive);
    }, [branches]);
    return {
        devices,
        getTopFiveDevices: () => devices,
    };
};
exports.useGetTopFiveElectricalEnergyUsage = useGetTopFiveElectricalEnergyUsage;
